// import React, { useEffect, useState } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Autoplay, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import { useFetch } from '../../../hooks/useFetch';
// import { getMediaURL } from '../../../utils/helpers';

// import './Slider.css';

// const Slider = () => {
//     const { data, loading, error } = useFetch('sliders', '?populate[Slider][populate]=*');
//     const [imagesLoaded, setImagesLoaded] = useState(false);
//     const [slides, setSlides] = useState([]);

//     // Extract all images and their URLs once data is available
//     useEffect(() => {
//         if (!loading && data?.length) {
//             const allSlides = data.flatMap(item =>
//                 item.Slider?.flatMap(sliderComp =>
//                     sliderComp.files?.map(file => ({
//                         imageUrl: file.url,
//                         linkUrl: file.url_field || sliderComp.url || null // Adjust based on your API structure
//                     })) || []
//                 ) || []
//             );

//             if (allSlides.length > 0) {
//                 const slidesWithFullUrls = allSlides.map(slide => ({
//                     imageUrl: getMediaURL(slide.imageUrl),
//                     linkUrl: slide.linkUrl
//                 }));
//                 setSlides(slidesWithFullUrls);
//             }
//         }
//     }, [data, loading]);

//     // Preload images
//     useEffect(() => {
//         if (!slides.length) return;

//         let loadedCount = 0;
//         slides.forEach((slide) => {
//             const img = new Image();
//             img.src = slide.imageUrl;
//             img.onload = () => {
//                 loadedCount++;
//                 if (loadedCount === slides.length) {
//                     setImagesLoaded(true);
//                 }
//             };
//             img.onerror = () => {
//                 loadedCount++;
//                 if (loadedCount === slides.length) {
//                     setImagesLoaded(true);
//                 }
//             };
//         });
//     }, [slides]);

//     // Handle slide click
//     const handleSlideClick = (linkUrl) => {
//         if (linkUrl) {
//             window.location.href = linkUrl;
//         }
//     };

//     // Wait until data and images are ready
//     if (loading || !imagesLoaded) {
//         return (
//             <div className="flex justify-center items-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
//                 <p className="text-lg text-gray-600">Yükleniyor...</p>
//             </div>
//         );
//     }

//     if (error) return <p className="text-center text-red-600 py-8">Error loading slider: {error}</p>;
//     if (!slides.length) return <p className="text-center text-gray-600 py-8">No images found</p>;

//     return (
//         <div className="flex justify-center w-full max-w-[1200px] mx-auto py-4 md:py-10 px-4 md:px-6 lg:px-8 h-[50vh] md:h-[60vh] lg:h-[70vh] max-h-[300px] md:max-h-[400px] lg:max-h-[500px]">
//             <Swiper
//                 modules={[Navigation, Autoplay, Pagination]}
//                 spaceBetween={10}
//                 slidesPerView={1}
//                 loop={true}
//                 navigation
//                 pagination={{ clickable: true, dynamicBullets: true }}
//                 autoplay={{ delay: 2500, disableOnInteraction: false }}
//                 speed={800}
//                 className="w-full h-full"
//             >
//                 {slides.map((slide, index) => (
//                     <SwiperSlide key={index}>
//                         <div
//                             className={`flex-1 flex justify-center items-center bg-blue-100 w-full h-full rounded-lg relative overflow-hidden ${slide.linkUrl ? 'cursor-pointer' : ''}`}
//                             onClick={() => handleSlideClick(slide.linkUrl)}
//                         >
//                             <img
//                                 src={slide.imageUrl}
//                                 alt={`Slide ${index + 1}`}
//                                 className="w-full h-full object-cover rounded-lg"
//                             />
//                         </div>
//                     </SwiperSlide>
//                 ))}
//             </Swiper>
//         </div>
//     );
// };

// export default Slider;


// import React, { useEffect, useState, useMemo } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Autoplay, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import { useFetch } from '../../../hooks/useFetch';
// import { getMediaURL } from '../../../utils/helpers';
// import { API_ENDPOINTS } from '../../../config/constants';


// import './Slider.css';

// const Slider = () => {
//     const { data, loading, error } = useFetch(API_ENDPOINTS.SLIDES, '?populate[' + API_ENDPOINTS.SLIDER + '][populate]=*');
//     const [firstImageLoaded, setFirstImageLoaded] = useState(false);

//     // Memoize slides to avoid recalculation
//     const slides = useMemo(() => {
//         if (!data?.length) return [];

//         const allSlides = data.flatMap(item =>
//             item.Slider?.flatMap(sliderComp =>
//                 sliderComp.files?.map(file => ({
//                     imageUrl: getMediaURL(file.url),
//                     linkUrl: file.url_field || sliderComp.url || null
//                 })) || []
//             ) || []
//         );

//         return allSlides;
//     }, [data]);

//     // Preload only the first image for faster initial render
//     useEffect(() => {
//         if (!slides.length) return;

//         const img = new Image();
//         img.src = slides[0].imageUrl;
//         img.onload = () => setFirstImageLoaded(true);
//         img.onerror = () => setFirstImageLoaded(true);
//     }, [slides]);

//     const handleSlideClick = (linkUrl) => {
//         if (linkUrl) {
//             window.location.href = linkUrl;
//         }
//     };

//     // Show loading only while fetching data, not while preloading
//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
//                 <p className="text-lg text-gray-600">Yükleniyor...</p>
//             </div>
//         );
//     }

//     if (error) return <p className="text-center text-red-600 py-8">Error loading slider: {error}</p>;
//     if (!slides.length) return <p className="text-center text-gray-600 py-8">No images found</p>;

//     return (
//         <div className="flex justify-center w-full max-w-[1200px] mx-auto py-4 md:py-10 px-4 md:px-6 lg:px-8 h-[50vh] md:h-[60vh] lg:h-[70vh] max-h-[300px] md:max-h-[400px] lg:max-h-[500px]">
//             <Swiper
//                 modules={[Navigation, Autoplay, Pagination]}
//                 spaceBetween={10}
//                 slidesPerView={1}
//                 loop={slides.length > 1}
//                 navigation
//                 pagination={{ clickable: true, dynamicBullets: true }}
//                 autoplay={{
//                     delay: 2500,
//                     disableOnInteraction: false,
//                     waitForTransition: true
//                 }}
//                 speed={800}
//                 lazy={{
//                     loadPrevNext: true,
//                     loadPrevNextAmount: 2
//                 }}
//                 preloadImages={false}
//                 className="w-full h-full"
//             >
//                 {slides.map((slide, index) => (
//                     <SwiperSlide key={index}>
//                         <div
//                             className={`flex-1 flex justify-center items-center bg-gray-200 w-full h-full rounded-lg relative overflow-hidden ${slide.linkUrl ? 'cursor-pointer' : ''}`}
//                             onClick={() => handleSlideClick(slide.linkUrl)}
//                         >
//                             <img
//                                 src={slide.imageUrl}
//                                 alt={`Slide ${index + 1}`}
//                                 className="w-full h-full object-cover rounded-lg swiper-lazy"
//                                 loading={index === 0 ? "eager" : "lazy"}
//                             />
//                             {/* Optional: Loading spinner for lazy images */}
//                             {index > 0 && (
//                                 <div className="swiper-lazy-preloader"></div>
//                             )}
//                         </div>
//                     </SwiperSlide>
//                 ))}
//             </Swiper>
//         </div>
//     );
// };

// export default Slider;









import React, { useEffect, useState, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { HiExternalLink } from 'react-icons/hi';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useFetch } from '../../../hooks/useFetch';
import { getMediaURL } from '../../../utils/helpers';
import { API_ENDPOINTS } from '../../../config/constants';

import './Slider.css';

const Slider = ({ API_ENDPOINTS_SLIDER = API_ENDPOINTS.SLIDES,
    PARAMS_SLIDER = `populate[${API_ENDPOINTS.SLIDER}][populate]=*&sort=publishedAt:desc`,
    slug }) => {

    // const { data, loading, error } = useFetch(
    //     API_ENDPOINTS_SLIDER,
    //     '?' + PARAMS_SLIDER
    // );

    const { data, loading, error } = useFetch(
        API_ENDPOINTS_SLIDER,
        slug
            ? `?filters[slug][$eq]=${slug}&${PARAMS_SLIDER}`
            : `?${PARAMS_SLIDER}`
    );


    // const { data, loading, error } = useFetch(
    //     API_ENDPOINTS.SLIDES,
    //     `?populate[${API_ENDPOINTS.SLIDER}][populate]=*&sort=publishedAt:desc`
    // );
    const [firstImageLoaded, setFirstImageLoaded] = useState(false);
    const [swiperInstance, setSwiperInstance] = useState(null);

    // const slides = useMemo(() => {
    //     if (!data?.length) return [];
    //     return data.flatMap(item =>
    //         item.Slider?.flatMap(sliderComp =>
    //             sliderComp.files?.map(file => ({
    //                 imageUrl: getMediaURL(file.url),
    //                 linkUrl: file.url_field || sliderComp.url || null
    //             })) || []
    //         ) || []
    //     );
    // }, [data]);


    const slides = useMemo(() => {
        if (!data) return [];

        // Helper: Recursively search the object for the "Slider" key
        const findSlider = (obj) => {
            if (!obj || typeof obj !== 'object') return null;
            if (Array.isArray(obj)) {
                for (let item of obj) {
                    const found = findSlider(item);
                    if (found) return found;
                }
            }
            if (obj.hasOwnProperty('Slider') && Array.isArray(obj.Slider)) {
                return obj.Slider;
            }
            for (let key in obj) {
                const found = findSlider(obj[key]);
                if (found) return found;
            }
            return null;
        };

        // Normalize data (works for single object or array)
        const items = Array.isArray(data) ? data : [data];

        return items.flatMap(item => {
            const sliderSource = findSlider(item);

            if (!sliderSource) return [];

            return sliderSource.flatMap(sliderComp =>
                sliderComp.files?.map(file => ({
                    imageUrl: getMediaURL(file.url),
                    linkUrl: file.url_field || sliderComp.url || null
                })) || []
            );
        });
    }, [data]);


    useEffect(() => {
        if (!slides.length) return;
        const img = new Image();
        img.src = slides[0].imageUrl;
        img.onload = () => setFirstImageLoaded(true);
        img.onerror = () => setFirstImageLoaded(true);
    }, [slides]);

    const handleSlideClick = (linkUrl) => {
        if (linkUrl) window.open(linkUrl, '_blank', 'noopener,noreferrer');
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
                <div className="animate-pulse">
                    <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (error) return <p className="text-center text-red-600 py-8">Error loading slider: {error}</p>;
    if (!slides.length) return <p className="text-center text-gray-600 py-8">No images found</p>;

    return (
        <div className="flex justify-center w-full max-w-[1200px] mx-auto py-4 md:py-10 px-4 md:px-6 lg:px-8 h-[50vh] md:h-[60vh] lg:h-[70vh] max-h-[300px] md:max-h-[400px] lg:max-h-[500px]">
            <Swiper
                modules={[Navigation, Autoplay, Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                loop={slides.length > 1}
                onSwiper={setSwiperInstance}
                pagination={{ clickable: true, dynamicBullets: false }}
                autoplay={{ delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true, waitForTransition: true }}
                speed={600}
                lazy={{ loadPrevNext: true, loadPrevNextAmount: 2 }}
                preloadimages="false"
                className="w-full h-full"
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className={`slide-content ${slide.linkUrl ? 'has-link' : ''}`}
                            onClick={() => handleSlideClick(slide.linkUrl)}
                            role={slide.linkUrl ? "button" : "presentation"}
                            aria-label={slide.linkUrl ? `Slide ${index + 1} - Click to open link` : `Slide ${index + 1}`}
                        >
                            <img
                                src={slide.imageUrl}
                                alt={`Slide ${index + 1}`}
                                className="w-full h-full object-cover swiper-lazy"
                                loading={index === 0 ? "eager" : "lazy"}
                            />
                            {index > 0 && <div className="swiper-lazy-preloader"></div>}
                            {slide.linkUrl && (
                                <div className="link-indicator">
                                    <span className="link-indicator-text">Tıklayın</span>
                                    <HiExternalLink className="link-indicator-icon" size={16} />
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                ))}

                {/* Navigation Arrows */}
                <div className="swiper-button-prev" onClick={() => swiperInstance?.slidePrev()}>
                    <IoChevronBack className="arrow-icon" size={24} />
                </div>
                <div className="swiper-button-next" onClick={() => swiperInstance?.slideNext()}>
                    <IoChevronForward className="arrow-icon" size={24} />
                </div>
            </Swiper>
        </div>
    );
};

export default Slider;